import React from "react";
import { useParams } from "react-router-dom";

import RegisterComponent from "@/components/screens/Register";
import { REGISTER_MESSAGES } from "@/messages/register/register.messages";
import { type Language } from "@/types/language.types";

const Register: React.FC = () => {
  useParams<{ lang?: Language }>();
  return <RegisterComponent messages={REGISTER_MESSAGES} />;
};

export default Register;
